/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { XERC20, XERC20Interface } from "../XERC20";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "_factory",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "IXERC20_LimitsTooHigh",
    type: "error",
  },
  {
    inputs: [],
    name: "IXERC20_NotFactory",
    type: "error",
  },
  {
    inputs: [],
    name: "IXERC20_NotHighEnoughLimits",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_mintingLimit",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_burningLimit",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_bridge",
        type: "address",
      },
    ],
    name: "BridgeLimitsSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_lockbox",
        type: "address",
      },
    ],
    name: "LockboxSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FACTORY",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "bridges",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "timestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "ratePerSecond",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "currentLimit",
            type: "uint256",
          },
        ],
        internalType: "struct IXERC20.BridgeParameters",
        name: "minterParams",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "timestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "ratePerSecond",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "currentLimit",
            type: "uint256",
          },
        ],
        internalType: "struct IXERC20.BridgeParameters",
        name: "burnerParams",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lockbox",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lockbox",
        type: "address",
      },
    ],
    name: "setLockbox",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_mintingLimit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_burningLimit",
        type: "uint256",
      },
    ],
    name: "setLimits",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address",
      },
    ],
    name: "mintingMaxLimitOf",
    outputs: [
      {
        internalType: "uint256",
        name: "_limit",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address",
      },
    ],
    name: "burningMaxLimitOf",
    outputs: [
      {
        internalType: "uint256",
        name: "_limit",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address",
      },
    ],
    name: "mintingCurrentLimitOf",
    outputs: [
      {
        internalType: "uint256",
        name: "_limit",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address",
      },
    ],
    name: "burningCurrentLimitOf",
    outputs: [
      {
        internalType: "uint256",
        name: "_limit",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type XERC20ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: XERC20ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class XERC20__factory extends ContractFactory {
  constructor(...args: XERC20ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "XERC20";
  }

  deploy(
    _name: string,
    _symbol: string,
    _factory: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<XERC20> {
    return super.deploy(
      _name,
      _symbol,
      _factory,
      overrides || {}
    ) as Promise<XERC20>;
  }
  getDeployTransaction(
    _name: string,
    _symbol: string,
    _factory: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _name,
      _symbol,
      _factory,
      overrides || {}
    );
  }
  attach(address: string): XERC20 {
    return super.attach(address) as XERC20;
  }
  connect(signer: Signer): XERC20__factory {
    return super.connect(signer) as XERC20__factory;
  }
  static readonly contractName: "XERC20";
  public readonly contractName: "XERC20";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): XERC20Interface {
    return new utils.Interface(_abi) as XERC20Interface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): XERC20 {
    return new Contract(address, _abi, signerOrProvider) as XERC20;
  }
}
